import React, { useMemo } from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import RowDetail from "../components/detail/RowDetail";
import RowDetailList from "../components/detail/RowDetailList";
import HtmlRenderDisponibiliteEtendu from "../components/HtmlRender/HtmlRenderDisponibiliteEtendu";
//Styles:

interface IProps {
    NoticeResult: INoticeDetails;
}

const Bloc4: React.FC<IProps> = ({
  NoticeResult
}) => {

  const getDisponibilite = useMemo(() => {
    return <HtmlRenderDisponibiliteEtendu Item={NoticeResult?.disponibiliteEtendue} />;
  }, [NoticeResult?.disponibiliteEtendue]);

  const formatDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split('-') ; // Décompose la chaîne "AAAA-MM-JJ"
    return `${day}/${month}/${year}`; // Réorganise en "JJ/MM/AAAA"
  };
  return (
    <>
      <div className="card" style={{ textAlign: 'left' }}>
              <div className="card-body pae-card-grey">
              <div className="row">
                  <div className="col-4 pae-detail-label">
                    <b>{getDisponibilite}</b>
                  </div>
                  <div className="col-4 pae-detail-label">
                    <b>{NoticeResult.prixTTC} {NoticeResult.prixDevise}</b> 
                  </div>
                  <div className="col-4 pae-detail-label" style={{ textAlign: 'right' }}>
                    <b>{NoticeResult?.dateParution && formatDate(NoticeResult?.dateParution)}</b>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 card-body">
                <RowDetailList titre="EAN" donnees={NoticeResult?.EansJustes} titreCol="4" donneeCol="8" />
                <RowDetail titre="ISBN" donnee={NoticeResult?.ISBN} />
                
                <RowDetailList titre="Editeur" donnees={NoticeResult?.Editeurs?.map(e => e.editeurLibelle)} titreCol="4" donneeCol="8"/>
                
                {(NoticeResult?.OrigineContenu !== null && NoticeResult?.OrigineContenu !== '') ? (
                    <RowDetail titre="Origine du contenu" donnee={NoticeResult?.OrigineContenu} />
                  ) : (
                    NoticeResult?.distributeur !== null && NoticeResult?.distributeur !== '' && NoticeResult?.typeProduitId !== null 
                    && NoticeResult?.typeProduitId !== '' && (
                      NoticeResult?.typeProduitId === 'TPEBO' ? (
                        <RowDetail titre="E-distributeur" donnee={NoticeResult?.distributeur} />
                      ) : (
                        <RowDetail titre="Distributeur" donnee={NoticeResult?.distributeur} />
                      )
                    )
                  )}

               {((NoticeResult?.MentionsEdition !== null && NoticeResult?.MentionsEdition !== '') 
               || (NoticeResult?.libelleTypeProduit !== null && NoticeResult?.libelleTypeProduit !== '' 
                && NoticeResult?.libelleTypeProduit?.toLocaleLowerCase() === "impression à la demande")) 
               && <br/>}
                   {NoticeResult?.MentionsEdition !== null && NoticeResult?.MentionsEdition !== '' && (
                      <RowDetail titre="" donnee={NoticeResult?.MentionsEdition} titreCol="4" donneeCol="8"/>
                  )}
                   {NoticeResult?.libelleTypeProduit !== null && NoticeResult?.libelleTypeProduit !== '' 
                && NoticeResult?.libelleTypeProduit?.toLocaleLowerCase() === "impression à la demande" && (
                      <RowDetail donnee={NoticeResult?.libelleTypeProduit} titreCol="4" donneeCol="8"/>
                  )}
              </div>
            </div>         
            <br></br>
    </>
  );
};

export default Bloc4;
